module.exports = __webpack_public_path__ + "img/V.993eaaeb.png";